import { normalizePostBody } from './postBody';

export const createDeletePostMessageBuilder = (t) => (post) => {
    const base = t("home.postCard.deleteDialog.base");
    const guidance = t("home.postCard.deleteDialog.guidance");
    const defaultMessage = t("home.postCard.deleteDialog.default", { base, guidance });

    if (!post) {
        return defaultMessage;
    }

    const source = normalizePostBody(post?.body);
    const cleaned = source.replace(/\s+/g, " ").trim();
    if (!cleaned) {
        return defaultMessage;
    }

    const snippet = cleaned.slice(0, 120);
    const displaySnippet = snippet ? `“${snippet}${cleaned.length > 120 ? "…" : ""}”` : "";

    if (!displaySnippet) {
        return defaultMessage;
    }

    return t("home.postCard.deleteDialog.withSnippet", {
        base,
        snippet: displaySnippet,
        guidance,
    });
};

export default createDeletePostMessageBuilder;
